import React, { useEffect, useState } from "react";

const DynamicSettingsLink = ({staticURI, dynamicURI, staticTitle})=>{
    const [alimToken,setAlimToken]=useState(null);

    const updateAlimToken=()=>{
        setAlimToken(localStorage.getItem('alim-login-token'));
    }

    const handleNavigation=()=>{
        if(alimToken!==null)
        {
            window.location=dynamicURI;
        }
        else
        {
            window.location=staticURI;
        }
    }

    useEffect(()=>{
        const loginHandler=()=>{
            updateAlimToken();
        }
        document.addEventListener("alim-login",loginHandler);

        return()=>{
            document.removeEventListener("alim-login", loginHandler);
        }
    });

    useEffect(()=>{},[alimToken]);

    useEffect(()=>{
        updateAlimToken();
    },[]);

    return(
        <button className="block text-left md:text-center text-white items-center justify-between w-full py-2 pl-3 pr-4 hover:text-deep-red lg:p-0 lg:w-auto lg:dark:hover:text-deep-red dark:focus:text-deep-red" onClick={handleNavigation}>
            {staticTitle}
        </button>
    );
}

export default DynamicSettingsLink;